import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProfilePage() {
  const { user, updateUserProfile } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const displayName = user?.name || user?.email || 'Editor';

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    const result = await updateUserProfile({ name: name.trim() });
    setLoading(false);
    if (!result.ok) {
      setError(result.message);
      return;
    }
    setSuccess('Your profile has been updated.');
  };

  return (
    <div className="page-frame profile-page">
      <div className="page-container">
        <div className="page-heading compact-heading">
          <div className="eyebrow">Account</div>
          <h1>Your KinetoCut profile</h1>
          <p>Keep your identity current and review how your account fits into the editing experience.</p>
        </div>

        <div className="profile-layout">
          <aside className="profile-summary">
            <div className="profile-avatar">{displayName[0].toUpperCase()}</div>
            <h2>{displayName}</h2>
            <p>{user?.email}</p>
            <span className="account-status"><i /> Account active</span>
            <div className="profile-divider" />
            <div className="profile-promise">
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 3 5 6v5c0 4.4 2.8 8.3 7 10 4.2-1.7 7-5.6 7-10V6l-7-3Zm-3 9 2 2 4-4" /></svg>
              <div><strong>Your media, your control</strong><p>Account changes never alter the original files used in a project.</p></div>
            </div>
            <Link className="text-link profile-support-link" to="/support">Visit support <span>→</span></Link>
          </aside>

          <section className="profile-card">
            <div className="card-heading">
              <div><span className="card-kicker">Profile details</span><h2>How you appear</h2></div>
              <span className="card-icon">✦</span>
            </div>
            <form className="profile-form" onSubmit={handleSubmit} aria-busy={loading}>
              <div className="form-row">
                <label htmlFor="profile-email">Email address</label>
                <div className="input-wrap input-disabled">
                  <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M4 6h16v12H4V6Zm0 1 8 6 8-6" /></svg>
                  <input id="profile-email" type="email" value={user?.email || ''} className="input" disabled />
                </div>
                <small>Your sign-in email cannot be changed here.</small>
              </div>
              <div className="form-row">
                <label htmlFor="profile-name">Display name</label>
                <div className="input-wrap">
                  <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>
                  <input
                    id="profile-name"
                    type="text"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    className="input"
                    autoComplete="name"
                    placeholder="Your display name"
                    disabled={loading}
                    required
                  />
                </div>
              </div>

              {error && <div className="status-box status-error" role="alert"><span>!</span><p>{error}</p></div>}
              {success && <div className="status-box status-success" role="status"><span>✓</span><p>{success}</p></div>}

              <div className="profile-form-actions">
                <button type="submit" className="button button-primary button-large" disabled={loading}>
                  {loading && <span className="spinner spinner-dark" />}
                  {loading ? 'Saving changes…' : 'Save changes'}
                </button>
                <p>Changes appear across KinetoCut after saving.</p>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}
